import * as Models from 'models';
import { getDesktopBrandStyles } from './getDesktopBrandStyles';

export const getFontSizeFromBrandStyle = (brandStyle: Models.BrandStyleMap): number => {
  const desktopStyles = getDesktopBrandStyles(brandStyle);

  return parseInt(desktopStyles.get(Models.BrandStyleProp.FONT_SIZE), 10);
};
